// extracted by mini-css-extract-plugin
export default {"form":"Login_form__5n2LA","login":"Login_login__6yK7k","input":"Login_input__4w1AH","inputEmail":"Login_inputEmail__yO+kC","buton":"Login_buton__51ydW","logo":"Login_logo__tBTNk"};